import React from 'react'
import { Link } from 'react-router'
import { useIntl } from 'react-intl'

import { ROUTES } from 'consts'
import { cn } from 'utils'

import messages from './messages'
import ArrowRight from './ArrowRight'

const Breadcrumbs = ({ breadcrumbs = [], className }) => {
  const { formatMessage } = useIntl()
  const allBreadcrumbs = [
    {
      id: 'dashboard',
      name: formatMessage(messages.home),
      route: ROUTES.DASHBOARD,
    },
    ...breadcrumbs,
  ]

  return (
    <div className={cn('flex gap-2 flex-wrap', className)}>
      {allBreadcrumbs.map(({ id, route, name }) => (
        <Link key={id || name} className="flex gap-2 " to={route}>
          <span className="text-label-11 whitespace-nowrap">{name}</span>
          <ArrowRight />
        </Link>
      ))}
    </div>
  )
}

export default Breadcrumbs
